// extracted by mini-css-extract-plugin
module.exports = {"button":"Product_button__2pX3o","photo":"Product_photo__1jGDh","icon":"Product_icon__1LNfj","name":"Product_name__iXByP","selected":"Product_selected__2jSRr"};